var map = {
	"./180/2021/modality.json": 8750,
	"./180/2021/numType.json": 33673,
	"./180/2021/situation.json": 53279,
	"./190/2021/childrenCalculation.json": 24592,
	"./190/2021/contractOrRelationship.json": 29263,
	"./190/2021/familySituation.json": 91674,
	"./190/2021/perceptionKey.json": 3687,
	"./190/2021/perceptionSubkey.json": 75288,
	"./190/2021/perceptorDisability.json": 63028,
	"./190/2023/complementarySupportChildhood.json": 19667,
	"./190/2023/ownerLivingUnit.json": 18854,
	"./202/2018/paymentMethod.json": 31401,
	"./202/2018/territoryForal.json": 33489,
	"./202/2023/territoryForal.json": 22178,
	"./202/2023/typePercent.json": 5746,
	"./347/2021/binaryOpt.json": 89450,
	"./347/2021/inmovableSituation.json": 35,
	"./347/2021/numType.json": 26621,
	"./347/2021/operationKey.json": 20539,
	"./349/2022/operationKey.json": 44253,
	"./349/2022/rectificationKey.json": 23936,
	"./349/2022/rectificationPeriod.json": 43325,
	"./activity.json": 19179,
	"./activity2022.json": 90225,
	"./cnae.json": 81730,
	"./countries.json": 635,
	"./europeCountries.json": 13908,
	"./europeCountriesWithSpain.json": 32167,
	"./nifType.json": 97708,
	"./paymentMethods.json": 40971,
	"./periods.json": 81669,
	"./provinces.json": 52115,
	"./roadTypes.json": 17963,
	"./towns.json": 51693,
	"./typeDeclaration.json": 33060,
	"./typePercent.json": 69369,
	"./vatRecords/2022/capitalGoodsAmortizationMethod.json": 74630,
	"./vatRecords/2022/capitalGoodsGoodType.json": 8973,
	"./vatRecords/2022/capitalGoodsGoodUnsubscribeReason.json": 38429,
	"./vatRecords/2022/capitalGoodsPeriod.json": 22119,
	"./vatRecords/2022/code.json": 89801,
	"./vatRecords/2022/issuedChargeMediumUsed.json": 53135,
	"./vatRecords/2022/issuedIncomeConcept.json": 8741,
	"./vatRecords/2022/issuedInvoiceType.json": 70919,
	"./vatRecords/2022/issuedOperationExempt.json": 11634,
	"./vatRecords/2022/issuedOperationKey.json": 90996,
	"./vatRecords/2022/issuedOperationQualification.json": 44079,
	"./vatRecords/2022/issuedReceivedPeriod.json": 80554,
	"./vatRecords/2022/receivedBillType.json": 94882,
	"./vatRecords/2022/receivedDeductionPeriodPeriod.json": 41061,
	"./vatRecords/2022/receivedExpenseConcept.json": 50776,
	"./vatRecords/2022/receivedOperationKey.json": 12454,
	"./vatRecords/2022/receivedPaymentMean.json": 46146,
	"./vatRecords/2022/type.json": 13570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5826;